// extracted by mini-css-extract-plugin
export default {"escalationTagCtn":"escalationTag_escalationTagCtn__HaDeh"};